import React from 'react';
import { t } from '../../../../locales/i18n';
import { time2str } from '../../../../utils/date-utils';
import { BHEntry } from '../../../../types/business-hours';
import { DatePicker } from '../../../../components/forms/date-picker';
import { QSContainer, QSPanelPrimary, QSPanelSecondary, QSPanelAction } from './layout-components';
import { Button } from 'semantic-ui-react';

interface EntryProps {
  entry: BHEntry;
  onChange: (fieldName: string, value: string) => void;
  onDelete: (entry: BHEntry) => void;
}

export function Entry(props: EntryProps) {
  const { entry, onChange, onDelete } = props;
  if (!entry) {
    return null;
  }
  return (
    <QSContainer>
      <QSPanelPrimary>
        <strong>{entry.weekDay && t(`days.${entry.weekDay}`)}</strong>
      </QSPanelPrimary>
      <QSPanelSecondary>
        <DatePicker type="time" onChange={(val) => onChange('from', time2str(val))} value={props.entry.from} />
        <DatePicker type="time" onChange={(val) => onChange('to', time2str(val))} value={props.entry.to} />
      </QSPanelSecondary>
      <QSPanelAction>
        <Button basic circular icon="close" negative onClick={() => onDelete(props.entry)} />
      </QSPanelAction>
    </QSContainer>
  );
}
